import './UpdateSubClientAccess.css';
import { subClientAccessOptions } from '../../utilities/services/clientOptions';
import { updateSubClientAccess } from '../../utilities/api/subClients';
import { useState } from 'react';

export default function UpdateSubClientAccess({user, client, subClient, updateSubClients, toggleNotifications}) {
    const [isLoading, setIsLoading] = useState(false);

    const handleSubClientAccessUpdate = async (evt) => {
        try {
            const newAccessLevel = evt.target.value;
            setIsLoading(true);
            const response = await updateSubClientAccess(user._id, subClient._id, { type: newAccessLevel });
            await updateSubClients((prevSubClients) => {
                return prevSubClients.map((sc) => sc._id === subClient._id ? response : sc);
            });
            toggleNotifications('success', 'Sub-client access updated successfully', "#FFFFFF");
        } catch (error) {
            console.error('Error updating sub-client access:', error);
            toggleNotifications('error', 'Error updating sub-client access', "#FFFFFF");
        } finally {
            setIsLoading(false);
        }
    }

  return (
    <div className='UpdateSubClientAccess'>
        <select className='form-select' name="accessLevel" id={`accessLevel-${subClient._id}`} defaultValue={subClient.type} onChange={handleSubClientAccessUpdate} disabled={isLoading}>
            {subClientAccessOptions.map((option, index) => (
                <option key={index} value={option.value}>{option.label}</option>
            ))}
        </select>
    </div>
  )
}
